import {Component, computed, inject, input} from '@angular/core';
import {RouterLink} from "@angular/router";
import {ButtonModule} from "primeng/button";
import {UserService} from "../../services/user.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {TodoItem, requiredTodoItems} from "../../todo-item.values";

@Component({
  standalone: true,
  selector: 'homey-start-next-step-button',
  imports: [RouterLink, ButtonModule],
  templateUrl: './start-next-step-button.component.html',
})
export class StartNextStepButtonComponent {
  private readonly userService = inject(UserService);
  private readonly user = toSignal(this.userService.getCurrentUserAfterSignupFlow$());

  readonly label = input<string | undefined>(undefined);
  readonly size = input<'small' | 'large' | undefined>(undefined);

  protected readonly nextIncompleteStep = computed(() => {
    const user = this.user();

    if (!user) {
      return undefined;
    }

    const items = requiredTodoItems;
    const recommended = items.find((item: TodoItem) => item.getStatus(user) === 'recommended');

    if (recommended) {
      return recommended;
    }

    return items.find((item: TodoItem) => item.getStatus(user) === 'not-started');
  });

  protected readonly displayLabel = computed(() => this.label() ?? this.nextIncompleteStep()?.stepLabel ?? 'Start next step');
  protected readonly nextStepRoute = computed(() => {
    const step = this.nextIncompleteStep();

    if (!step) {
      return undefined;
    }

    return ['/profile', ...step.link];
  });
}
